var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 34.125C7 32.9647 7.46094 31.8519 8.28141 31.0314C9.10188 30.2109 10.2147 29.75 11.375 29.75H35",
    stroke: "#CE0000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 3.5H35V38.5H11.375C10.2147 38.5 9.10188 38.0391 8.28141 37.2186C7.46094 36.3981 7 35.2853 7 34.125V7.875C7 6.71468 7.46094 5.60188 8.28141 4.78141C9.10188 3.96094 10.2147 3.5 11.375 3.5Z",
    stroke: "#5570F1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookContent);
export default __webpack_public_path__ + "static/media/book-content.aefa11ede719200e56607f4746060023.svg";
export { ForwardRef as ReactComponent };